import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Interaccion/Edit/{id}',
  documento: 'crm',
  filas: ['145'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/InteraccionController.cs',
} satisfies RutaProd;
